export function friendlyFormatNumber(n: number): string {
    return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
  };

  export function convertToHoursAndMinutes (totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    return `${friendlyFormatNumber(hours)}h ${friendlyFormatNumber(minutes)}m`;
  };